import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionsV2Service } from '../../../../../services/collectionsV2.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'app-default-slots-config',
  templateUrl: './default-slots-config.component.html',
  styleUrls: ['./default-slots-config.component.scss'],
})
export class DefaultSlotsConfigComponent implements OnInit {
  @Input() data;
  @Input() linkedPartners;
  @Input() vehicles;
  @Input() areas;
  @Input() isWorkshop : boolean = true;
  @Input() isRentals : boolean = false;
  @Output() close = new EventEmitter();
  public saving = false;
  public selectedPartners: any = [];
  public selectedVehicles: any = [];
  public selectedAreas: any = [];
  public days = [0, 1, 2, 3, 4, 5, 6];

  constructor(
    private collectionsService: CollectionsV2Service,
    private helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    /*var availablePartners = [];
                this.vehicles.map(x => { return x.linkedPartners.map(y=>{ availablePartners.push(y.partnerID)}) });
                this.areas.map(x => { return x.linkedPartners.map(y=>{ availablePartners.push(y.partnerID)}) });
                this.linkedPartners = this.linkedPartners.filter(x=>{return availablePartners.includes(x.partnerID)});*/

    if (this.data.linkedVehicles) {
      this.selectedVehicles = this.data.linkedVehicles.map((x) => {
        return x.deliveryVehicleID.toString();
      });
    }
    if (this.data.linkedAreas) {
      this.selectedAreas = this.data.linkedAreas.map((x) => {
        return x.areaID.toString();
      });
    }
    // if (this.data.linkedPartners) {
    //   this.selectedPartners = this.data.linkedPartners.map(x => { return x.partnerID.toString() });
    // }
  }

  valid() {
    return (
      this.data.dayOfWeek >= 0 &&
      this.data.dayOfWeek < 7 &&
      this.data.slotStartTime &&
      this.data.slotEndTime &&
      this.data.slotEndTime > this.data.slotStartTime &&
      //&& this.selectedPartners.length > 0
      (this.data.bufferDays === 0 &&
      this.data.cutOffTime >= this.data.slotStartTime
        ? false
        : true) &&
      this.selectedVehicles.length > 0 &&
      this.selectedAreas.length > 0
    );
  }

  save() {
    this.saving = true;
    var request = JSON.parse(JSON.stringify(this.data));
    request.slotStartTime = moment(this.data.slotStartTime).format('HH:mm:ss');
    request.slotEndTime = moment(this.data.slotEndTime).format('HH:mm:ss');
    request.cutOffTime = moment(this.data.cutOffTime).format('HH:mm:ss');
    request.linkedPartners = this.selectedPartners.map((x) => {
      return { partnerID: x };
    });
    request.linkedVehicles = this.selectedVehicles.map((x) => {
      return { deliveryVehicleID: x };
    });
    request.linkedAreas = this.selectedAreas.map((x) => {
      return { areaID: x };
    });
    request.workshopLinked = this.isWorkshop;
    request.rentalsLinked = this.isRentals;

    if (request.id) {
      this.collectionsService.updateDefaultSlots(request).subscribe(
        (res) => {
          this.saving = false;
          this.close.emit('');
        },
        (err) => {
          this.saving = false;
        },
      );
    } else {
      this.collectionsService
        .addDefaultSlots(this.helpersService.getPartnerId(), request)
        .subscribe(
          (res) => {
            this.saving = false;
            this.close.emit('');
          },
          (err) => {
            this.saving = false;
          },
        );
    }
  }

  dayOfWeek(val) {
    switch (val) {
      case 0:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.sunday',
        );
      case 1:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.monday',
        );
      case 2:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.tuesday',
        );
      case 3:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.wednesday',
        );
      case 4:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.thursday',
        );
      case 5:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.friday',
        );
      case 6:
        return this.translate.instant(
          'bikeshop.shop_profile.collections.saturday',
        );
    }
  }

  formatCutOffTime(val) {
    return moment(val).format('h:mm A');
  }

  getBufferDay(dayOfWeek, buffer) {
    var diff = dayOfWeek - buffer;
    return diff < 0 ? 7 + diff : diff;
  }

  clearAreas(vehicle, val) {
    if (!val) {
      vehicle.linkedAreas.map((x) => {
        if (this.selectedAreas.indexOf(x.areaID.toString()) > -1) {
          this.selectedAreas.splice(
            this.selectedAreas.indexOf(x.areaID.toString()),
            1,
          );
        }
      });
      this.selectedAreas = JSON.parse(JSON.stringify(this.selectedAreas));
    }
  }

  canAreaBeSelected(area) {
    var allowedAreas = [];
    this.vehicles
      .filter((x) => {
        return this.selectedVehicles.includes(x.id.toString());
      })
      .map((x) => {
        return x.linkedAreas.map((y) => {
          allowedAreas.push(y.areaID);
        });
      });
    return allowedAreas.indexOf(area.id) > -1;
  }
}
